import { Modal, Button, Form, FormItem } from '@frontend/design_system'
import { UploadDocuments } from 'ui/components/UploadDocuments'
import { CANCEL } from 'texts/uiTexts'
import { useCompanyId } from 'hooks/useCompanyId'
import { useUploadDocuments } from 'hooks/useUploadDocuments'
import { FormChildren, FormItemChildren } from 'types/form'
import { UserDocuments } from 'types/documents'
import { DocumentsControlModalProps } from './types'
import { ADD } from 'texts/common'
import { DOCUMENT_CONTROL_MODAL_TITLE, REPLACE } from 'texts/agreements'
import { DocumentsModalVariant } from '../../types'
import styles from './styles.module.scss'

export const DocumentsControlModal = ({
  onModalClose,
  id,
  onReload,
  variant = DocumentsModalVariant.Add,
}: DocumentsControlModalProps) => {
  const companyId = useCompanyId()

  const { uploadDocuments, loading } = useUploadDocuments()

  const onSubmit = async (
    data: { files: UserDocuments },
    validate: boolean
  ) => {
    if (validate) {
      const response = await uploadDocuments(data.files, String(companyId))
      if (response) {
        onModalClose()
        onReload()
      }
    }
  }

  return (
    <Modal
      position="center-horizontal"
      onClose={onModalClose}
      title={DOCUMENT_CONTROL_MODAL_TITLE[variant]}
      headerSize="large"
      isDelimiter
      disableOverlayClose
    >
      <Form
        onSubmit={onSubmit}
        initValues={{ files: [] }}
        className={styles['modal-content']}
      >
        {({ isDirty }: FormChildren) => (
          <div className={styles['modal-wrapper']}>
            <FormItem id="files">
              {({ onChange }: FormItemChildren) => (
                <UploadDocuments onChangeSelectedFiles={onChange} id={id} />
              )}
            </FormItem>
            <div className={styles['buttons-wrapper']}>
              <Button
                label={CANCEL}
                variant="secondary-border"
                size="large"
                onClick={onModalClose}
              />
              <Button
                label={variant === DocumentsModalVariant.Add ? ADD : REPLACE}
                size="large"
                htmlType="submit"
                loading={loading}
                disabled={!isDirty}
              />
            </div>
          </div>
        )}
      </Form>
    </Modal>
  )
}
